<div class="static-content">
  <span class="static-content-label" *ngIf="!ignoreTitleCase">
    {{ title | titlecase }}
  </span>
  <span class="static-content-label" *ngIf="ignoreTitleCase">{{ title }}</span>
  <p>{{ value }}</p>
</div>
